import { FC, useEffect } from 'react';

import { CoreSessionStorage } from '../../storage/session/CoreSessionStorage';
import { createGameStore } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';

import { ChatCommunicationController } from './chatCommunicationController';
import type { IChatCommunicationProcessor } from './types';

export const chatCommunicationController = new ChatCommunicationController();

export const ChatCommunicationControllerConnector: FC<{
  gameStore: ReturnType<typeof createGameStore>;
  processors?: IChatCommunicationProcessor[];
}> = ({ gameStore, processors }) => {
  const chatWS = useConfigSlice.env()?.chatWS;
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const userId = useConfigSlice.playerConfig()?.userId;
  const tableId = useConfigSlice.tableId();
  const casinoId = useConfigSlice.casinoConfig()?.casinoId;
  const tableName = useConfigSlice.tableConfig()?.tableName;
  const showOtherMessages = useConfigSlice.showOtherMessages();
  const isSubtitlesAvailable = useConfigSlice.isSubtitlesAvailable();
  const isSubtitlesEnabled = useConfigSlice.isSubtitlesEnabled();
  const subtitlesEnabled = isSubtitlesAvailable && isSubtitlesEnabled;

  useEffect(() => {
    if (processors) {
      processors.forEach((processor) => chatCommunicationController.setProcessor(processor));
    }

    chatCommunicationController.setStore(gameStore);
  }, [processors, gameStore]);

  useEffect(() => {
    if (JSESSIONID && tableId && userId && chatWS && casinoId && tableName) {
      const timestamp = Date.now();
      const subtitlesLanguage = CoreSessionStorage.getLang().toLowerCase();

      chatCommunicationController.connect(
        chatWS,
        JSESSIONID,
        userId,
        tableId,
        casinoId,
        tableName,
        `${userId}_${timestamp}`,
        showOtherMessages,
        subtitlesEnabled,
        subtitlesLanguage
      );
    }
  }, [chatWS, JSESSIONID, userId, tableId, casinoId, tableName, showOtherMessages, subtitlesEnabled]);

  return null;
};
